export const APPS_CATALOG_QUERY_KEY = ["apps-catalog"] as const;
export const OPERATION_QUERY_KEY = ["operations"] as const;
export const OPERATION_HISTORY_QUERY_KEY = [...OPERATION_QUERY_KEY, "history"] as const;
export const OPERATION_PER_APP_QUERY_KEY = [...OPERATION_QUERY_KEY, "per-app"] as const;
